export default "__VITE_ASSET__9dfee91e__"